<!-- eslint-disable no-unused-vars -->
<template>
  <div v-if="isOnline">
    <!-- ADMIN -->
    <div v-if="$route.meta.requiresAuth">
      <HeaderAdmin v-if="!$route.meta.hideNavBarAdmin" />
      <section>
        <SidebarAdminComponent v-if="!$route.meta.hideSideBarAdmin" />
      </section>
      <router-view></router-view>
    </div>

    <!-- LANDING PAGE -->
    <div v-else>
      <HeaderLanding v-if="!$route.meta.hideNavbar" />
      <section id="content-admin" class="d-lg-none d-md-none d-block">
        <SidebarLanding />
      </section>
      <router-view></router-view>
      <FooterLanding v-if="!$route.meta.hideFooter" />
      <a :href="waHref" target="_blank" @click="trackWa" class="wa-contact d-flex align-items-center justify-center"
        :class="[{ 'd-none': !isWaVisible }]">
        <i class="fab fa-whatsapp fa-xl"></i>
      </a>
    </div>
    <CookieNotice />
    <MarketingPrompt />
  </div>
  <div v-else>Network connection lost</div>
</template>

<script>
import { useRoute } from 'vue-router'
import { waUrl } from '@/utils/whatsapp'
import { useStore } from 'vuex'
import { reactive, onMounted, computed, ref, onBeforeUnmount } from 'vue'
import HeaderLanding from './components/landingpage/HeaderLanding.vue'
import HeaderAdmin from './components/admin/HeaderAdmin.vue'
import SidebarLanding from './components/landingpage/SidebarLanding.vue'
import SidebarAdminComponent from './components/admin/SidebarAdmin.vue'
import FooterLanding from './components/landingpage/FooterLanding.vue'
import CookieNotice from './components/CookieNotice.vue'
import MarketingPrompt from './components/MarketingPrompt.vue'
import { track } from '@/utils/analytics'

export default {
  name: 'App',
  components: {
    HeaderAdmin,
    SidebarLanding,
    HeaderLanding,
    FooterLanding,
    SidebarAdminComponent,
    CookieNotice,
    MarketingPrompt,
  },
  setup() {
    const store = useStore()
    const isOnline = ref(navigator.onLine)
    const route = useRoute()
    const routeName = computed(() => {
      return route.name
    })
    // Floating button: tagged [Umum] text carrying the current page path (recomputed on navigation).
    const waHref = computed(() => {
      void route.path
      if (route.name === 'in-house-training') {
        return waUrl('Perusahaan', 'Halo Dilatih, kami ingin konsultasi in-house training untuk tim.')
      }
      return waUrl('Umum', 'Halo Dilatih, saya ingin bertanya.')
    })
    const data = reactive({
      isLogin: false,
    })

    const isWaVisible = computed(() => {
      if (
        routeName.value == 'register' ||
        routeName.value == 'login' ||
        routeName.value == 'affiliate-login' ||
        routeName.value == 'webinar-register' ||
        routeName.value == 'workshop-register' ||
        routeName.value == 'forget-password' ||
        routeName.value == 'confirm-new-password' ||
        routeName.value == 'certificate-show-webinar-share' ||
        routeName.value == 'certificate-show-workshop-share' ||
        routeName.value == 'privacy' ||
        routeName.value == 'termsofservice' ||
        routeName.value == 'payment-register'

      ) {
        return false
      } else {
        return true
      }
    })

    function cek_login() {
      if (store.getters['auth/isLoggedIn']) {
        data.isLogin = true
      }
    }

    onMounted(() => {
      const updateOnlineStatus = () => {
        isOnline.value = navigator.onLine
      }

      window.addEventListener('online', updateOnlineStatus)
      window.addEventListener('offline', updateOnlineStatus)

      cek_login()
    })

    onBeforeUnmount(() => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    })

    function trackWa() {
      track('whatsapp_contact_clicked', { page: routeName.value || '' })
    }

    //return a state and function
    return {
      isWaVisible,
      routeName,
      data,
      isOnline,
      trackWa,
      waHref,
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@100;200;300;400;500;600;700;800;900&family=Righteous&family=Roboto:wght@100;300;400;500;700;900&display=swap');

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  scroll-behavior: smooth !important;
}
</style>
